
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'
import ButtonNavigation from '@/components/molecules/ButtonNavigation.vue'
import { InformationPanelColorSet } from '@/const/manage/InformationPanelColorSet'

/**
 * 管理側インフォメーションパネルのメインメニュー
 */
@Component({
  components: {
    ButtonBase,
    ImageBase,
    ButtonNavigation,
  },
})
export default class InformationPanelMain extends Vue {
  /** インフォメーションパネルのカラーセット */
  @Prop()
  private informationPanelColorSet!: InformationPanelColorSet.ColorSet

  /** ユーザボタン押下時のイベント */
  @Prop()
  private eventClickUserButton!: () => void

  /** 画面表示モードボタン押下時のイベント */
  @Prop()
  private eventClickToggleViewModeButton!: () => void

  /** インフォメーションパネルの開閉管理 */
  private isClose: boolean = true

  /**
   * インフォメーションパネルの色を設定する
   *
   * @returns css：カラー変数文字列
   */
  private get setStyle(): { [key: string]: string } {
    return {
      '--button-color': `var(${this.informationPanelColorSet.button})`,
      '--text-color': `var(${this.informationPanelColorSet.text})`,
    }
  }

  /**
   * インフォメーションパネルの状態を切り替える
   */
  private togglePanel(): void {
    this.isClose = !this.isClose
  }
}
